<template>
  <qx-card-form title="归属信息" v-show="showComponent">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px"></qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      showComponent: false,
      baseForm: {
        inline: true,
        form: [
          {
            label: '车队名称',
            value: 'tenantName',
            type: 'input',
            hide: false,
            disabled: true,
          },
          {
            label: '车队电话',
            value: 'linkPhone',
            type: 'input',
            hide: false,
            disabled: true,
          },
        ],
      },
    };
  },
  methods: {
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    sub () {
      return {};
    },
    setVal (oValue) {
      this.$refs.baseForm.setVal(oValue);
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.resetBaseForm();
      this.$refs.baseForm.setVal(data);
    },
    resetBaseForm () {
      this.showComponent = false;
    },
    formChange (vehicleInfo) {
      this.resetBaseForm();
      if (!this.$route.query.id) {
        // 动态设置归属信息组件里面的表单
        if (vehicleInfo.tenantId) {
          this.setVal({
            tenantName: vehicleInfo.tenantName,
            linkPhone: vehicleInfo.linkPhone,
          });
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: false,
          });
        } else {
          this.setVal({
            tenantName: '平台合作车',
            linkPhone: '',
          });
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: true,
            names: ['linkPhone'],
          });
        }
      }
      this.showComponent = true;
    },
    receivedData (vehicleInfo) {
      if (vehicleInfo) {
        this.formChange(vehicleInfo);
      } else {
        this.showComponent = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
